import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import PlanningAlerts from './PlanningAlerts';
import PlanningReport from './PlanningReport';

const propTypes = {

};

const defaultProps = {

};

function PlanningPanel () {
    const showReport = useSelector((state) => {
        const reducer = state.planningReducer;
        return Boolean(reducer.currentPlanningReportId !== null);
    });
    return !showReport ? <PlanningAlerts /> : <PlanningReport />;
}

PlanningPanel.propTypes = propTypes;
PlanningPanel.defaultProps = defaultProps;

export default PlanningPanel;